import React, { useState } from 'react';
import { X, Flag, Ban, VolumeX, Link2, ChevronLeft, Check, Share2, Send, MessageCircle, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { reportReasons } from '../mock';

const notify = (msg) => toast.success(msg, { style: { background: '#0f1622', color: '#fff', border: '1px solid #1c2634' } });

export default function ActionSheet({ open, name = 'this user', onClose }) {
  const [view, setView] = useState('menu');
  if (!open) return null;

  const close = () => { setView('menu'); onClose(); };
  const report = (reason) => { close(); notify(`Reported for “${reason}”. Our team will review it.`); };
  const block = () => { close(); notify(`${name} has been blocked.`); };
  const mute = () => { close(); notify(`${name} muted.`); };
  const share = (dest) => { close(); notify(dest); };

  const rows = [
    { Icon: Share2, label: 'Share', onClick: () => setView('share') },
    { Icon: Flag, label: 'Report', danger: true, onClick: () => setView('report') },
    { Icon: Ban, label: `Block ${name}`, danger: true, onClick: block },
    { Icon: VolumeX, label: 'Mute', onClick: mute },
    { Icon: Link2, label: 'Copy link', onClick: () => { close(); notify('Link copied'); } },
  ];

  const shareRows = [
    { Icon: Send, label: 'Send in a message', done: 'Sent in a message' },
    { Icon: Sparkles, label: 'Share to your Moments', done: 'Shared to your Moments' },
    { Icon: MessageCircle, label: 'Share to Chats', done: 'Shared to Chats' },
    { Icon: Link2, label: 'Copy link', done: 'Link copied' },
  ];

  return (
    <div className="fixed inset-0 z-[65] flex items-end justify-center" onClick={close}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative w-full max-w-[440px] bg-[#0c1420] rounded-t-3xl p-4 pb-6 animate-pop-in" onClick={(e) => e.stopPropagation()}>
        {view === 'menu' && (
          <>
            <div className="w-10 h-1 rounded-full bg-[#2a3547] mx-auto mb-4" />
            {rows.map((r) => (
              <button key={r.label} onClick={r.onClick} className="w-full flex items-center gap-3 px-2 py-3.5 rounded-xl hover:bg-[#0e1522] active:bg-[#0e1522] transition-colors">
                <r.Icon size={20} className={r.danger ? 'text-[#f43f5e]' : 'text-[#c4ccd8]'} />
                <span className={`text-[15px] ${r.danger ? 'text-[#f43f5e]' : 'text-white'}`}>{r.label}</span>
              </button>
            ))}
            <button onClick={close} className="w-full mt-2 py-3 rounded-xl bg-[#141c28] text-[15px] font-semibold text-white">Cancel</button>
          </>
        )}

        {view === 'share' && (
          <>
            <div className="flex items-center gap-2 mb-3">
              <button onClick={() => setView('menu')}><ChevronLeft size={22} className="text-white" /></button>
              <h3 className="font-display text-base font-bold text-white">Share</h3>
            </div>
            {shareRows.map((s) => (
              <button key={s.label} onClick={() => share(s.done)} className="w-full flex items-center gap-3 px-2 py-3.5 rounded-xl hover:bg-[#0e1522] transition-colors">
                <div className="w-9 h-9 rounded-full bg-[#141c28] flex items-center justify-center"><s.Icon size={18} className="text-[#2f8bff]" /></div>
                <span className="text-[15px] text-white">{s.label}</span>
              </button>
            ))}
          </>
        )}

        {view === 'report' && (
          <>
            <div className="flex items-center gap-2 mb-3">
              <button onClick={() => setView('menu')}><ChevronLeft size={22} className="text-white" /></button>
              <h3 className="font-display text-base font-bold text-white">Report</h3>
            </div>
            <p className="text-[13px] text-[#8b95a5] mb-3 px-1">Why are you reporting this?</p>
            <div className="max-h-72 overflow-y-auto app-scroll">
              {reportReasons.map((r) => (
                <button key={r} onClick={() => report(r)} className="w-full flex items-center justify-between px-3 py-3 rounded-xl hover:bg-[#0e1522] text-left">
                  <span className="text-[14px] text-white">{r}</span>
                  <Check size={16} className="text-[#5c6675]" />
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
